import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import './scss/style.scss';
import Page404 from "./views/page404/Page404";
import ProtectedRoute from "./components/Router/ProtectedRoute";

const Login = React.lazy(() => import('./views/login/Login'))

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));


class App extends Component {

    render() {
        return (
            <BrowserRouter>
                <React.Suspense fallback={loading}>
                    <Switch>
                        <Route path='/login' component={Login}/>
                        {/*<Route path="/" name="Home" render={props => <TheLayout {...props}/>}/>*/}
                        <ProtectedRoute path="/" name="Home" component={TheLayout}/>
                        <Route component={Page404}/>
                    </Switch>
                </React.Suspense>
            </BrowserRouter>
        );
    }
}

export default App;
